import React from 'react';
import Loading from 'src/components/Loading';
import withCotizacion from 'src/HOC/withCotizacion';
import useGenerarUrlPTP from 'src/hooks/useGenerarUrlPTP';
import useCustomToast from 'src/hooks/useCustomToast';
import useQueryString from 'src/hooks/useQueryString';
import { useHistory } from 'react-router-dom';

const GenerarUrlPTP = ({ idCotizacion }) => {
  const { addWarningToast } = useCustomToast();
  const { onErrorGoBack } = useQueryString();
  const history = useHistory();
  useGenerarUrlPTP({
    onComplete: (data) => {
      console.log('On Complete', data);
      window.location.href = data.url;
    },
    onError: (error) => {
      console.log('ingresa Error', error);
      if (onErrorGoBack) {
        history.push(`/newPaginaCompra/${idCotizacion}`);
      }
      addWarningToast(error?.data?.errorDescripcion || 'HA OCURRIDO UN PROBLEMA', {
        autoDismiss: false,
      });
      history.push(`/firmarCertificado/${idCotizacion}`);
    },
  });

  return <Loading secundario="Pronto seras redireccionado a PlaceToPay" />;
};

export default withCotizacion(GenerarUrlPTP);
